import React, { Component } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import CreateAttributeForm from '../components/CreateAttributeForm';
import axios from 'axios';
import { Panel, Col, Row, Button, FormControl, Form } from 'react-bootstrap';
import PlainPanel from '../components/PlainPanel';
import config from '../config';
import { Link } from 'react-router-dom';

import './CreateAttribute.css';

class CreateAttribute extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {}

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t('CreateAttribute.title')}`;

        const { uuid } = this.props.match.params;
        const attributepath = this.props.emailAttribute ? "emailattributes" : "attributes";

        return (
            <div className="CreateAttribute">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <div className="row">
                            <Col lg={12}>
                                <h1 className="page-header">{t('CreateAttribute.title')}</h1>
                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-tachometer-alt" />{' '}
                                        <Link to={`/organisations/${uuid}`}>{t('Dashboard.title')}</Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-tags" />{' '}
                                        <Link to={`/organisations/${uuid}/${attributepath}`}>
                                        {this.props.emailAttribute ? (

                                            t('SideNavigation.emailattributes')

                                            ) :  t('SideNavigation.attributes')}
                                        </Link>
                                    </li>
                                    <li className="active">
                                        <i className="fa fa-plus" /> {t('CreateAttribute.title')}
                                    </li>
                                </ol>

                                <PlainPanel>
                                    <CreateAttributeForm uuid={uuid} emailAttribute={this.props.emailAttribute} />
                                </PlainPanel>
                            </Col>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(CreateAttribute);
